import { Vue, Component, Prop } from 'vue-property-decorator';
import { Overlay } from '@/models/ui/overlay';

@Component
export default class LoadingOverlayComponent extends Vue {
    @Prop() overlay: Overlay

    get loadingText() {
        return this.overlay.options.text
    }
}
